import React, { useState, useEffect } from "react";
import axios from "axios";
import Select from "react-select"; 
import {
  Box,
  Typography,
  TextField,
  Paper,
  Button,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";


const AttendanceForm = () => {

     useEffect(()=>{
                  document.title="AttendanceForm | Balaji Badminton Academy"
                },[]);

  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); 
  
  const [formData, setFormData] = useState({
    name: "",
    personId: "",
    sport: "",
    date: "",
    fromTime: "",
    toTime: "",
    status: "",
    category: "",
  });

  const [names, setNames] = useState([]);
  const [attendanceList, setAttendanceList] = useState([]);
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    axios.get("https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/getNames").then((response) => {
      const namesArray = Object.values(response.data).map(person => ({
          id: person.personId,
          label: `${person.personId}-${person.name}`,
          value: person.name,
          gender: person.gender,
      }));
      setNames(namesArray); 
    });

    fetchAttendance();
  }, []);

  const fetchAttendance = async () => {
    const response = await axios.get("https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/getAttendance");
    setAttendanceList(response.data);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
  
    if (name === "status") {
      setFormData((prev) => ({
        ...prev,
        status: value,
        fromTime: value === "Present" ? prev.fromTime : "",
        toTime: value === "Present" ? prev.toTime : "",
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSelectChange = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setFormData((prev) => ({ ...prev, name: selectedOption.value, personId: selectedOption.id, gender: selectedOption.gender }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const formattedDate = new Date(formData.date).toLocaleDateString("en-GB");
      const payload = { ...formData, date: formattedDate };

      if (editId) {
        await axios.put(`https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/updateAttendance/${editId}`, payload);
        setMessage("Attendance updated successfully");
        setMessageType("success");
      } else {
        await axios.post("https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/addAttendance", payload);
        setMessage("Attendance added successfully");
        setMessageType("success");
      }

      setFormData({
        name: "",
        personId: "",
        sport: "",
        date: "",
        fromTime: "",
        toTime: "",
        status: "",
        category: "",
        gender: "",
      });
      setEditId(null);
      fetchAttendance();
    } catch (error) {
      console.error("Error submitting attendance:", error);
      setMessage("Failed to submit attendance");
      setMessageType("error");
    }
  };

  const handleEdit = (id) => {
    const entry = attendanceList.find((item) => item.id === id);
    if (entry) {
      const [day, month, year] = entry.date.split("/");
      const formattedDate = `${year}-${month}-${day}`;
  
      setFormData({
        ...entry,
        date: formattedDate,
        category: entry.category || "",
      });
      setEditId(id);
    }
  };
  
  
  

  const handleDelete = async (id) => {
    try {
      await axios.delete(`https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/deleteAttendance/${id}`);
      setMessage("Attendance deleted successfully");
      setMessageType("success");
      fetchAttendance();
    } catch (error) {
      console.error("Error deleting attendance:", error);
      setMessage("Failed to delete attendance");
      setMessageType("error");
    }
  };

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage("");
        setMessageType("");
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [message]);
  
  const isFormValid = () => {
    const { name, sport, date, status, category, fromTime, toTime } = formData;

    if (status === "Present" && (!fromTime || !toTime)) {
      return false;
    }

    return name && sport && date && status && category;
  };

  const columns = [
    { field: "index", headerName:"S.NO", width: 90},
    { field: "id", headerName: "EntryId", width: 90 },
    { field: "name", headerName: "Name", width: 100 },
    { field: "category", headerName: "Category", width: 100 },
    { field: "sport", headerName: "Sport", width: 100 },
    { field: "date", headerName: "Date", width: 100 },
    { field: "from", headerName: "From", width: 80 },
    { field: "to", headerName: "To", width: 80 },
    { field: "status", headerName: "Status", width: 90 },
    {
      field: "edit",
      headerName: "Edit",
      width: 100,
      renderCell: (params) => (
        <Button
          className="btn btn-warning"
          onClick={() => handleEdit(params.row.id)}
        >
          Edit
        </Button>
      ),
    },
    {
      field: "delete",
      headerName: "Delete",
      width: 100,
      renderCell: (params) => (
        <Button
          className="btn btn-danger"
          onClick={() => handleDelete(params.row.id)}
        >
          Delete
        </Button>
      ),
    },
  ];
  
  
  const rows = attendanceList.map((entry, index) => ({
    index: index+1,
    id: entry.id,
    name: entry.name,
    category: entry.category,
    sport: entry.sport,
    date: entry.date,
    from: entry.fromTime || "N/A",
    to: entry.toTime || "N/A",
    status: entry.status,
  }));
  

  return (
    <div className="container">
      <h3 className="p-4 text-center mb-4">Attendance Form</h3>
      <form onSubmit={handleSubmit}>
      <div className="row mb-3">
        <div className="col-md-3">
          <label>Name:</label>
          <Select
            options={names}
            value={names.find((option) => option.value === formData.name)}
            onChange={handleSelectChange}
            placeholder="Select or search a name"
            required
          />
        </div>
        <div className="col-md-3">
          <label>Category:</label>
          <select
            className="form-control"
            name="category"
            value={formData.category}
            onChange={handleChange}
            required
          >
            <option value="">Select Category</option>
            <option value="Single">Single</option>
            <option value="Membership">Membership</option>
          </select>
        </div>

        <div className="col-md-3">
          <label>Sport:</label>
          <select
            className="form-control"
            name="sport"
            value={formData.sport}
            onChange={handleChange}
            required
          >
            <option value="">Select Sport</option>
            <option value="Badminton">Badminton</option>
            <option value="Cricket">Dance</option>
            <option value="Yoga">Yoga</option>
          </select>
        </div>
        <div className="col-md-3">
          <label>Date:</label>
          <input
            type="date"
            className="form-control"
            name="date"
            value={formData.date}
            onChange={handleChange}
            required
          />
        </div>
        </div>
        <div className="row mb-3">
        <div className="col-md-3">
          <label>Status:</label>
          <select
            className="form-control"
            name="status"
            value={formData.status}
            onChange={handleChange}
            required
          >
            <option value="">Select Status</option>
            <option value="Present">Present</option>
            <option value="Half Day">Half Day</option>
            <option value="Leave">Leave</option>
          </select>
        </div>
        <div className="col-md-3">
          <label>From:</label>
          <input
            type="time"
            className="form-control"
            name="fromTime"
            value={formData.fromTime}
            onChange={handleChange}
            required={formData.status === "Present"  & "Half Day"}
            disabled={formData.status !== "Present" & "Half Day"}
          />
        </div>
        <div className="col-md-3">
          <label>To:</label>
          <input
            type="time"
            className="form-control"
            name="toTime"
            value={formData.toTime}
            onChange={handleChange}
            required={formData.status === "Present"  & "Half Day"}
            disabled={formData.status !== "Present"  & "Half Day"}
          />
        </div>
       
        </div>
        {message && (
          <div className={`alert ${messageType === "success" ? "alert-success" : "alert-danger"}`}>
            {message}
          </div>
        )}

        <button type="submit" className="btn mt-3" disabled={!isFormValid()}>
          {editId ? "Update" : "Submit"}
        </button>

      </form>

       <Box sx={{ padding: 4 }}>
          
      
                <Paper sx={{ height: "auto", width: "100%" }}>
                <DataGrid
                  rows={rows}
                  columns={columns}
                  pageSize={5}
                  rowsPerPageOptions={[5, 10, 20]}
                  disableSelectionOnClick
                  autoHeight
                  sortingOrder={['asc', 'desc']}
                  
                  
                />
                </Paper>
                </Box>
    </div>
  );
};

export default AttendanceForm;
